export default "__VITE_ASSET__1c82b211__"